// 该文件在vite-plugin-permission-generator自动生成
// 不要手动编辑此文件，它会在每次权限变更时自动生成

export const PERMISSIONS = {
  "开户管理/充值记录/导出记录": "business:recharge:export",
  "开户管理/广告账户/充值": "business:ad_account:recharge",
  "开户管理/广告账户/授权": "business:ad_account:authorization",
  "开户管理/广告账户/记录导出": "business:ad_account:export",
  "开户管理/开户申请/申请开户": "business:account_application:create",
  "开户管理/开户申请记录/复制记录": "business:account_records:copy",
  "开户管理/开户申请记录/编辑记录": "business:account_records:edit",
  "开户管理/开户申请记录/记录导出": "business:account_record:export",
  "开户管理/开户申请记录/记录详情": "business:account_record:query",
  "开户管理/开户申请记录/银联验证": "business:account_records:verify",
  "成员&权限/成员管理/启用状态切换": "business:member_management:switch_status",
  "成员&权限/成员管理/查看(角色编辑)": "business:member_management:edit",
  "成员&权限/成员管理/移除成员": "business:member_user:remove",
  "成员&权限/成员管理/邀请成员": "business:member_user:add",
  "成员&权限/角色管理/修改角色权限": "business:role_management:update_permissions",
  "成员&权限/角色管理/删除角色": "business:role_management:delete",
  "成员&权限/角色管理/新增角色": "business:role_management:create",
  "成员&权限/角色管理/编辑角色": "business:role_management:edit",
  "数据看板/账户消耗统计/导出记录": "business:account_consumption:export",
  "短剧库管理/上传短剧": "business:mini_series_library:upload_mini_series",
  "短剧库管理/上架短剧": "business:mini_series_library:approve_mini_series",
  "短剧库管理/下架短剧": "business:mini_series_library:disapprove_mini_series",
  "短剧库管理/删除短剧": "business:mini_series_library:delete_mini_series",
  "短剧库管理/删除短剧库": "business:mini_series_library:delete",
  "短剧库管理/新增短剧库": "business:mini_series_library:create",
  "短剧库管理/申诉短剧": "business:mini_series_library:appeal_mini_series",
  "短剧库管理/编辑短剧": "business:mini_series_library:update_mini_series",
  "短剧库管理/编辑短剧库": "business:mini_series_library:update",
  "财务管理/支付订单/导出记录": "business:payment_orders:export"
} as const;

export type PermissionPath = keyof typeof PERMISSIONS;
export type PermissionCode = (typeof PERMISSIONS)[PermissionPath];
